import { apiClient } from "@/services/apiClient";

/** The canonical slugs. The server owns this list; never hardcode a copy. */
export type UyDepartment = string;

export interface ProfessionalCoverage {
  /** The departments this professional covers. */
  departments: UyDepartment[];
  /**
   * The full vocabulary to choose from, served ALONGSIDE the selection.
   *
   * Deliberately not a client-side constant: a hardcoded list of nineteen
   * names drifts from the server's, and the drift shows up as a department the
   * professional can tick and the server then rejects.
   */
  available: UyDepartment[];
}

export function getMyCoverageAreas(): Promise<ProfessionalCoverage> {
  return apiClient
    .get<ProfessionalCoverage>("/me/coverage-areas")
    .then((res) => res.data);
}

/**
 * Replace the whole set.
 *
 * Replace, not add/remove: the control is a multi-select, so what the
 * professional means is "these are my departments". A delta API over a
 * checkbox list merges two open tabs into a union neither of them chose.
 */
export function replaceMyCoverageAreas(
  departments: UyDepartment[],
): Promise<{ departments: UyDepartment[] }> {
  return apiClient
    .put<{ departments: UyDepartment[] }>("/me/coverage-areas", { departments })
    .then((res) => res.data);
}
